import Vue from "vue";
import Vuex from "vuex";
import Cookies from "js-cookie";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    screenLoading: true,
    loggedIn: Cookies.get("livnex_cookie_authKey") && Cookies.get("livnex_cookie_authKey") != undefined && Cookies.get("livnex_cookie_loginKeepFlg") == "1",
    serverLogged: false,
    cleverlyHomeFlg: false,
    manualDispFlg: false,
    isMainDomain: false,
  },
  mutations: {
    setScreenLoading(state, val) {
      state.screenLoading = val;
    },
    setLoggedIn(state, val) {
      state.loggedIn = val;
    },
    setServerLogged(state, val) {
      state.serverLogged = val;
    },
    setCleverlyHomeFlg(state, val) {
      state.cleverlyHomeFlg = val;
    },
    setManualDispFlg(state, val) {
      state.manualDispFlg = val;
    },
    setIsMainDomain(state, val) {
      state.isMainDomain = val;
    },
  },
  getters: {
    getScreenLoading: (state) => {
      return state.screenLoading;
    },
    getLoggedIn: (state) => {
      return state.loggedIn;
    },
    getServerLogged: (state) => {
      return state.serverLogged;
    },
    getCleverlyHomeFlg: (state) => {
      return state.cleverlyHomeFlg;
    },
    getManualDispFlg: (state) => {
      return state.manualDispFlg;
    },
  },
});
